import { create } from "zustand";

interface ComparisonStore {
  open: boolean;
  productIds: string[];
  openComparison: (productIds: string[]) => void;
  close: () => void;
}

export const useComparisonStore = create<ComparisonStore>()((set) => ({
  open: false,
  productIds: [],
  openComparison: (productIds) => set({ open: true, productIds }),
  close: () => set({ open: false, productIds: [] }),
}));
